export default __webpack_public_path__ + "93acc5946a79d870bd16b90f994b2668.svg";